import { NumberField } from 'Shared/forms/Inputs';
import { LabelOnRightWrap } from 'Shared/forms/Wrap';
import { StyleFieldsRow } from 'Shared/backend/styles/StyleFieldsRow';


export function LetterSpacing()
{
	return (
		<StyleFieldsRow>
			<LetterSpacingFields />
		</StyleFieldsRow>
	);
}


/* The spacing on its own, for a caller that names the location itself - see ruleProperties(). A bare
   number renders as px, exactly as the venue overlay css used to write it. */
export function LetterSpacingFields()
{
	return (
		<LabelOnRightWrap label='px' narrow={true}>
			<NumberField field='spacing' step={0.5} />
		</LabelOnRightWrap>
	);
}
